import React from 'react'
import Select from 'react-select'
import dynamic from 'next/dynamic'
import { FormGroup, Label } from 'reactstrap'
import { firstLetter } from 'common'
import useTranslation from '../hooks/UseTranslation'
import { ScriptContext } from '../contexts/ScriptContext'

const AddressSearch = dynamic(() => import('./AddressSearch'), {
  ssr: false
})

const LocationAndAddress = (props) => {
  const { t } = useTranslation()
  const { locationProps, addressProps, disabled } = props
  const [selectedLocation, setSelectedLocation] = React.useState(
    props.selectedLocation
  )
  const [selectedAddress, setSelectedAddress] = React.useState(
    props.selectedAddress
  )
  const { placesLoaded } = React.useContext(ScriptContext)
  React.useEffect(() => {
    setSelectedLocation(props.selectedLocation)
  }, [props.selectedLocation])
  React.useEffect(() => {
    setSelectedAddress(props.selectedAddress)
  }, [props.selectedAddress])
  return (
    <div>
      <FormGroup>
        <Label className='form-label' for={locationProps.name}>
          {t(locationProps.label)}
        </Label>
        <Select
          isSearchable={false}
          id={locationProps.name}
          name={locationProps.name}
          options={locationProps.options}
          isDisabled={disabled}
          isMulti={false}
          className='selectpicker'
          classNamePrefix='selectpicker'
          placeholder={firstLetter(t('default_select_placeholder'))}
          value={selectedLocation}
          defaultValue={selectedLocation}
          onChange={props.onSelectedLocation}
        />
      </FormGroup>
      {placesLoaded && (
        <AddressSearch
          label={t(addressProps.label)}
          value={selectedAddress}
          disabled={disabled || !selectedLocation}
          cityLatLng={{
            lat: selectedLocation?.value.lat,
            lng: selectedLocation?.value.lng
          }}
          onSelected={props.onSelectedAddress}
        />
      )}
    </div>
  )
}

export default LocationAndAddress
